import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { VehiclePurchasableExtraList } from "@/app/Vehicles/Components/VehiclePurchasableExtraList";

export function VehiclePurchasableExtraDialog({
  vehicleId,
}: {
  vehicleId: string;
}) {
  return (
    <BaseDialog
      title="Purchasable Extras"
      subtitle="Add / Remove purchasable extras on a per vehicle basis"
    >
      <VehiclePurchasableExtraList vehicleId={vehicleId} />
    </BaseDialog>
  );
}
